import _slicedToArray from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from 'react-i18next';
import { useBestBuyUserConfig, useBestBuyInputAmount, useBestBuyPair } from "../../../../state/dex/hooks";
import { useModalOpened, useModalSwitch } from "../../../../state/application/hooks";
import { ApplicationModal } from "../../../../state/application/reducer";
import TokenLogo from "../../../TokenLogo";
import PreviewInfo from "../PreviewInfo";
import TradeButton from "../TradeButton";
import { formatNumber } from "../../../../utils/numbers";
import { StyledOrderPreview, StyledHeader, BackButton, Title, Content, StyledLabel, StyledMainContent, StyledTokenPairWrapper, TokenRow, StyledTokenSymbol, StyledText, StyledButtons, StyledAdjustButton } from "./styled";
import IconSwapArrow from "../../../../assets/images/swap-arrow.svg";
import IconBackArrow from "../../../../assets/images/arrow-left-outlined.svg";

var OrderPreview = () => {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useBestBuyPair = useBestBuyPair(),
      _useBestBuyPair2 = _slicedToArray(_useBestBuyPair, 2),
      inputToken = _useBestBuyPair2[0],
      outputToken = _useBestBuyPair2[1];

  var _useBestBuyInputAmoun = useBestBuyInputAmount(),
      inputAmount = _useBestBuyInputAmoun.inputAmount;

  var _useBestBuyUserConfig = useBestBuyUserConfig(),
      expiration = _useBestBuyUserConfig.expiration,
      rate = _useBestBuyUserConfig.rate;

  var _expiration$split = expiration.split('_'),
      _expiration$split2 = _slicedToArray(_expiration$split, 2),
      expirationValue = _expiration$split2[0],
      expirationUnit = _expiration$split2[1];

  var isPreviewOpen = useModalOpened(ApplicationModal.BEST_BUY_ORDER_PREVIEW);
  var switchReview = useModalSwitch(ApplicationModal.BEST_BUY_ORDER_PREVIEW);

  var onClose = () => {
    switchReview(false, {
      stack: true
    });
  };

  if (!isPreviewOpen) return null;
  return __jsx(StyledOrderPreview, null, __jsx(StyledHeader, null, __jsx(BackButton, null, __jsx("img", {
    src: IconBackArrow,
    onClick: onClose
  })), __jsx(Title, null, t('preview_order'))), __jsx(Content, null, __jsx(StyledMainContent, null, __jsx(StyledTokenPairWrapper, null, __jsx("div", null, __jsx(StyledLabel, null, t('sell_token')), __jsx(TokenRow, null, __jsx(TokenLogo, {
    logo: inputToken === null || inputToken === void 0 ? void 0 : inputToken.logo,
    symbol: inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol,
    space: 0
  }), __jsx(StyledTokenSymbol, null, inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol))), __jsx("img", {
    src: IconSwapArrow,
    className: "arrow-icon"
  }), __jsx("div", null, __jsx(StyledLabel, null, t('buy_token')), __jsx(TokenRow, null, __jsx(TokenLogo, {
    logo: outputToken === null || outputToken === void 0 ? void 0 : outputToken.logo,
    symbol: outputToken === null || outputToken === void 0 ? void 0 : outputToken.symbol,
    space: 0
  }), __jsx(StyledTokenSymbol, null, outputToken === null || outputToken === void 0 ? void 0 : outputToken.symbol)))), __jsx("div", null, __jsx(StyledLabel, null, t('trigger_price')), __jsx(StyledText, null, __jsx("span", null, "1 ".concat(outputToken === null || outputToken === void 0 ? void 0 : outputToken.symbol, " = ")), __jsx("span", {
    className: "highLight"
  }, formatNumber(rate)), __jsx("span", null, " ".concat(inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol)))), __jsx("div", null, __jsx(StyledLabel, null, t('total_amount')), __jsx(StyledText, null, __jsx("span", {
    className: "highLight"
  }, inputAmount), __jsx("span", null, " ".concat(inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol)))), __jsx("div", null, __jsx(StyledLabel, null, t('duration')), __jsx(StyledText, null, __jsx("span", {
    className: "highLight"
  }, expirationValue), __jsx("span", null, " ".concat(t(expirationUnit)))))), __jsx(PreviewInfo, null), __jsx(StyledButtons, null, __jsx(StyledAdjustButton, {
    onClick: onClose
  }, t('modify_order')), __jsx(TradeButton, null))));
};

export default OrderPreview;